// This is the SUPPORTED_CURRENCIES list from wf.utils.currencies, but in alphabetical order

import type { Item } from "@wayflyer/flyui";

import type { SupportedCountry } from "./countries";

// c.f. https://github.com/wayflyer/utils/blob/main/wf/utils/currencies.py
export type Currency =
  | "AUD"
  | "CAD"
  | "CHF"
  | "DKK"
  | "EUR"
  | "GBP"
  | "HKD"
  | "HUF"
  | "JPY"
  | "MXN"
  | "NOK"
  | "NZD"
  | "PLN"
  | "RUB"
  | "SEK"
  | "SGD"
  | "USD";

export const CURRENCIES = [
  "AUD",
  "CAD",
  "CHF",
  "DKK",
  "EUR",
  "GBP",
  "HKD",
  "HUF",
  "JPY",
  "MXN",
  "NOK",
  "NZD",
  "PLN",
  "RUB",
  "SEK",
  "SGD",
  "USD",
] as const satisfies readonly Currency[];

export type SupportedCurrency = Extract<Currency, "EUR" | "GBP" | "USD" | "AUD" | "CAD" | "DKK" | "SEK">;

export const SUPPORTED_CURRENCIES = [
  "EUR",
  "GBP",
  "USD",
  "AUD",
  "CAD",
  "DKK",
  "SEK",
] as const satisfies readonly SupportedCurrency[];

export const MCA_CURRENCY_OPTIONS: { label: SupportedCurrency; value: SupportedCurrency }[] = [
  { label: "EUR", value: "EUR" },
  { label: "USD", value: "USD" },
  { label: "GBP", value: "GBP" },
  { label: "AUD", value: "AUD" },
  { label: "CAD", value: "CAD" },
  { label: "DKK", value: "DKK" },
  { label: "SEK", value: "SEK" },
];

export const currencyOptions: Item<Currency>[] = MCA_CURRENCY_OPTIONS.map((currency) => {
  return { id: currency.value, text: currency.label };
});

export const isEuroCountry = (countryCode: string) => {
  return ["BE", "DE", "IE", "ES", "NL"].includes(countryCode);
};

export const COUNTRY_CURRENCY_MAP: Record<string, SupportedCurrency> = {
  AU: "AUD",
  CA: "CAD",
  DK: "DKK",
  EU: "EUR",
  GB: "GBP",
  SE: "SEK",
  US: "USD",
};

export const getCurrencyFromCountry = (countryCode: SupportedCountry): SupportedCurrency => {
  const country = isEuroCountry(countryCode) ? "EU" : countryCode;
  return COUNTRY_CURRENCY_MAP[country];
};
